import DashboardLayout from "../layouts/DashboardLayout";
import VerifiedMember from "../middlewares/VerifiedMember";
import Dashboard from "../pages/neutral/Dashboard";
import ScheduleProceeding from "../pages/neutral/ScheduleProceeding";
import CaseDetail from "../pages/neutral/CaseDetail";
import { getCaseDetail, getCases } from "../adapters/caseResolution";
import { getProceedings } from "../adapters/proceedings";
import IsLawyerProfile from "../middlewares/isLawyerProfile";
import NoPage from '../pages/NoPage';
import {
    getAuthToken
} from '../adapters/authentication';

const authGuard = () => {
    const token = getAuthToken();
    return token !== null && token !== undefined
}

export const lawyerRoutes = [
    {
        path: "/neutral",
        element: <VerifiedMember>
            <IsLawyerProfile>
                <DashboardLayout />
            </IsLawyerProfile>
        </VerifiedMember>,   

        errorElement: <NoPage />,
        
        children: [
            {
                path: "dashboard",
                element: <Dashboard />,
                loader: async () => {
                    if(authGuard()){
                        try {
                            const cases = await getCases().then((res) => res.data);
                            const proceedings = await getProceedings((res) => res.data); 
                            return {
                                cases, proceedings
                            }
                        } catch (e) {
                            throw new Response("Not Found",{
                                status: 503
                            });
                        }
                    }
                    return ;
                }
            },

            {
                path: 'schedule-meeting/:caseId',
                element: <ScheduleProceeding />
            },

            {
                path: "case-detail/:id",
                element: <CaseDetail />,
                loader: async ({ params }) => {
                    if(authGuard()){
                        return await getCaseDetail(params.id).then((res) => {
                            if (res.status === 200) {
                                return res.data
                            } else {
                                throw new Response("Not Found", {
                                    status: 404
                                });
                            }
                        });
                    }
                    return;
                }
            }
        ]
    }
];